import React from 'react';
import Image from 'next/image';
import { Flex, Box } from '@skin-seoul/design-system';
type PaymentMethod = {
  id: number;
  name: string;
  image: string;
};
const paymentMethods: PaymentMethod[] = [{
  id: 1,
  name: 'Discover',
  image: 'https://skin-seoul.com/wp-content/uploads/2024/12/discover.png'
}, {
  id: 2,
  name: 'MasterCard',
  image: 'https://skin-seoul.com/wp-content/uploads/2024/12/mastercard.png'
}, {
  id: 3,
  name: 'PayPal',
  image: 'https://skin-seoul.com/wp-content/uploads/2024/12/paypal.png'
}, {
  id: 4,
  name: 'Visa',
  image: 'https://skin-seoul.com/wp-content/uploads/2024/12/visa-card.png'
}, {
  id: 5,
  name: 'American Express',
  image: 'https://skin-seoul.com/wp-content/uploads/2024/12/american-express.png'
}];
const PaymentMethods = () => {
  return <Flex alignItems="center" gap={{
    base: 4,
    mobile: 5,
    tablet: 10,
    desktop: '58px'
  }} justifyContent="flex-start" flexWrap="nowrap" overflow="hidden" data-sentry-element="Flex" data-sentry-component="PaymentMethods" data-sentry-source-file="PaymentMethods.tsx">
      {paymentMethods.map(method => <Box key={method.id} position="relative" flexShrink={1} minWidth="0">
          <Image alt={method.name} src={method.image} width={100} height={31} style={{
        height: '31px',
        maxWidth: 'auto',
        objectFit: 'contain',
        maxHeight: '31px'
      }} unoptimized />
        </Box>)}
    </Flex>;
};
export default PaymentMethods;